export default __webpack_public_path__ + "images/6159cd0a1a65051256f32ef4411faa62.jpg";